import { AxiosError } from 'axios';

type ServerErrorData = {
  message?: string;
  error?: string;
  // allow any other fields without using `any`
  [key: string]: unknown;
};

type AxiosErrorWithServerMessage = AxiosError<ServerErrorData> & {
  serverMessage?: string;
};

const apiErrorHandler = (error: AxiosError<ServerErrorData>) => {
  if (error.response) {
    const {
      response: { status, data },
    } = error;

    switch (status) {
      case 401:
        break;
      case 400:
        break;
      case 500:
      case 404:
        break;
      default:
        break;
    }
    // Attach server-provided message if available (without spamming console)
    if (data && typeof data === 'object') {
      const typedData = data as ServerErrorData;
      (error as AxiosErrorWithServerMessage).serverMessage = typedData.message ?? typedData.error ?? undefined;
    }
  }
  throw error;
};

export default apiErrorHandler;
